type IMAGE_TYPE = {
  id: string;
  pk: string;
  file: string;
  file_type: string;
  campaign: string;
  collection: string;
  request_id: string;
  job: string;
  created_at: string;
  updated_at: string;
};

export const ImageCard = (data: IMAGE_TYPE) => {
  var color;

  if (data.collection === "gallery-images") {
    const file = data.file.split("_");
    color = file[file.length - 1].split(".")[0];
  }

  if (data.collection === "proof-images") {
    const file = data.file.split("-");
    color = file[file.length - 1].split(".")[0];
  }

  return (
    <div className="w-full h-full center-items content-center justify-center">
      <div className="center-items content-center justify-center border">
        <img alt="" src={data.file} className="h-full w-full object-contain" />
      </div>
      {color ? (
        <div>
          <p className="text-xs">color: </p>
          <p>{color}</p>
        </div>
      ) : (
        <div></div>
      )}
      <a
        className="text-xs underline"
        download={data.file.substring(data.file.lastIndexOf("/") + 1)}
        href={data.file}
      >
        download
      </a>
    </div>
  );
};
